module.exports = "/images/logo_min.png?a8c0f0e4f8358f62a815ef82193dd02a";